import Cookies from 'universal-cookie';

export const SetCookieMessage = (cookieName, cookieValue) =>{
    const cookies = new Cookies();
    cookies.set(cookieName, cookieValue, { path: '/' });
}

export const GetCookieMessage = (cookieName, cookieDefault) =>{
    const cookies = new Cookies();
    return cookies.get(cookieName) ? cookies.get(cookieName) : cookieDefault;
}


